exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hwrld._24zO8DAi9C0J0r52SpuXqS {\n  border: 1px solid #CCCCCC;\n  border-radius: 2px;\n  position: relative;\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  overflow: hidden;\n  cursor: pointer;\n}\n.hwrld._24zO8DAi9C0J0r52SpuXqS::before, .hwrld._24zO8DAi9C0J0r52SpuXqS::after {\n  content: \"\";\n  position: absolute;\n  background: #565656;\n  height: 3px;\n  left: 2px;\n  top: 5px;\n  width: 9px;\n}\n.hwrld._24zO8DAi9C0J0r52SpuXqS::before {\n  transform: rotate(45deg);\n}\n.hwrld._24zO8DAi9C0J0r52SpuXqS::after {\n  transform: rotate(-45deg);\n}", ""]);

// exports
exports.locals = {
	"hwrld": "_24zO8DAi9C0J0r52SpuXqS"
};